import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useEffect} from "react";

import Offcanvas from "react-bootstrap/Offcanvas";
// -
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";

import axiApi from "ApiCaller";
import {updateListById} from "core/utils/arrays";

const FirmwareModel = {
    id: "",
    name: "",
    device_model: "",
    version: "",
    size: "",
    create_at: "",
};

const FormFirmware = ({show, setShow, item, items, setItemsShown, models}) => {
    const [formData, setFormData] = useState({...item});
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    useEffect(() => {
        setFormData({...item});
    }, [item]);

    const onChange = (event) => {
        const {id, value} = event.target;
        formData[id] = value;
        setFormData(formData);
    };
    const handleChangeFile = (e) => {
        if (e.target.files.length > 1) {
            Alert.error("Solo se permite un archivo");
            e.target.value = "";
        }
        const file = e.target.files[0];
        const id = file.id;
        let exists = items.current.all.find((_item) => _item.id === id);
        if (exists) {
            Alert.error(`El archivo: ${id} ya existe!!!`);
            e.target.value = "";
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    const clickCancel = () => {
        setShow(false);
    };

    const onSummit = (e) => {
        e.preventDefault();

        let form = new FormData(e.target);

        // Validar que se haya seleccionado un modelo
        if (!form.get("model")) {
            Alert.warning("Modelo requerido", "Debe seleccionar un modelo antes de subir el firmware");
            return;
        }

        axiApi.post("/api/devices/advanced/file/", form).then((resp) => {
            if (resp.data.status) {
                Alert.success("Firmware", "Se ha cargado el firmware");
                items.current.all.push(resp.data.item);
                items.current.showed.push(resp.data.item);
                setItemsShown([...items.current.showed]);
                setShow(false);
            } else {
                Alert.error("Error en el servidor", "No se ha podido cargar el firmware");
            }
        });
    };

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                aria-modal="true"
                style={{width: "40%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="heart-pulse" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>Firmware</Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form className="ms-auto" onSubmit={onSummit} encType="multipart/form-data">
                        <div className="row">
                            <div className="mt-3 col-12">
                                <label htmlFor="file-bin" className="form-label">
                                    Archivo
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="file-bin"
                                    name="file-bin"
                                    required
                                    onChange={handleChangeFile}
                                />
                            </div>
                            <div className="col mt-3" style={{maxWidth: "150px"}}>
                                <label htmlFor="version" className="form-label">
                                    Version
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="version"
                                    name="version"
                                    defaultValue={formData.version}
                                    placeholder="1.0.000"
                                    onChange={onChange}
                                    required
                                />
                            </div>
                            <div className="col mt-3" style={{maxWidth: "200px"}}>
                                <label htmlFor="model" className="form-label">
                                    Modelo
                                </label>
                                <select className="form-select" id="model" name="model" onChange={onChange} required>
                                    <option value="">Seleccione</option>
                                    {models.map((model, idx) => {
                                        return (
                                            <option value={model.model_id} key={idx}>
                                                {model.model_name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="mt-5 text-end mb-5">
                            <div className="mt-5 d-flex justify-content-end align-right">
                                <button type="button" className="btn btn-secondary" onClick={clickCancel}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary ms-3">
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormFirmware;
